export class Nozzle {
  id?: number | null;
  color?: string | null;
  model?: string | null;
  pressure?: number | null;
  flow?: number | null;
  startRange?: number | null;
  endRange?: number | null;

  constructor(dto?: Partial<Nozzle>) {
    Object.assign(this, dto);
  }
}
